import * as React from 'react';
//import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { Helper } from '../../Utils/Helper';
import { ServiceRequest } from "../../Utils/ServiceRequest";
import NewMysetting from "./newmysetting"
import "../Common/common.scss";
import MyMIPASettingobj from '../../Entity/MySettingobj';
import { MSListConfig } from '../../Entity/MySettingobj';
/*import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  //ContextualMenu,
  //Checkbox,
  //DefaultButton,
  Modal,
  //IDragOptions,
  IconButton
} from 'office-ui-fabric-react';
*/
import { TextField } from 'office-ui-fabric-react/lib/TextField';
//import { FontSizes } from '@uifabric/styling';


import {
  DetailsList, DetailsListLayoutMode, Selection, SelectionMode
  //  , IColumn 
} from 'office-ui-fabric-react/lib/DetailsList';
//import { runInThisContext } from 'vm';
export interface IProps {
  closeMethod,
  SettingInfo: MyMIPASettingobj,
  GraphHeader,
  Phrases,
  UserEmail,
  SiteURL,
  APIHeader,
  APIServiceurl,
  UpdateConfig,
  SacretaryList,
  Manager,
  AdminURL,
}

/*
// Themed styles for the example.
const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  header: [
    // tslint:disable-next-line:deprecation
    theme.fonts['xLargePlus'],
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      fontSize: FontSizes.xLarge,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 14px 24px'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: {
        margin: '14px 0'
      },
      'p:first-child': {
        marginTop: 0
      },
      'p:last-child': {
        marginBottom: 0
      }
    }
  }
});

const iconButtonStyles = mergeStyleSets({
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});

*/
export interface IDetailsListBasicExampleItem {
  key: number;
  name: string;
  value: number;
  id: string;
}

export interface IDetailsListBasicExampleState {
  items: IDetailsListBasicExampleItem[];
  selectionDetails: {};
}

export default class MySetting extends React.Component<IProps> {

  public RequestPending = 0;
  public ProgressIsShowing = false;
  public state = {
    isLoading: false,
    shownewlistmodal: false,
    items: [],
    selectionDetails: {},
    currentview: 'MSList'
  };
  public SRequest = new ServiceRequest();
  public FromValidationMessages = null;
  public currentgroupid = null;

  /*
  private _titleId: string = getId('title');
  private _subtitleId: string = getId('subText');
  */

  private _selection: Selection;
  private _allItems: IDetailsListBasicExampleItem[];
  //private _columns: IColumn[];
  public CategoryName: string;
  public CategoryHexColor: string;
  public CategoryId: string;
  public SelectedList: MSListConfig;
  public MySettingInfo: MyMIPASettingobj;
  constructor(props) {
    super(props);
    this._selection = new Selection({
      onSelectionChanged: () => this.setState({ selectionDetails: this._getSelectionDetails() })
    });
    this.CategoryId = Helper.newguid();
    this.CategoryName = '';
    this.CategoryHexColor = '';
    this.MySettingInfo = this.props.SettingInfo;
    /*
    // Populate with items for demos.
    this._allItems = [];
    for (let i = 0; i < 20; i++) {
      this._allItems.push({
        key: i,
        name: 'Item ' + i,
        value: i
      });
    }
 
    this._columns = [
      { key: 'column1', name: 'Name', fieldName: 'name', minWidth: 100, maxWidth: 200, isResizable: true },
      { key: 'column2', name: 'Value', fieldName: 'value', minWidth: 100, maxWidth: 200, isResizable: true }
    ];
*/
    this.state = {
      isLoading: false,
      shownewlistmodal: false,
      items: this._allItems,
      selectionDetails: this._getSelectionDetails(),
      currentview: 'MSList'
    };
  }
  /*public state: IModalBasicExampleState = {
    showModal: true,
    isDraggable: true
  };*/
  // Use getId() to ensure that the IDs are unique on the page.
  // (It's also okay to use plain strings without getId() and manually ensure uniqueness.)



  public render() {
    /*
      this.PrepareFacepile();
      let plandropdownitem=[];
      this.props.plans.forEach(p=> {
        plandropdownitem.push({key:p.id,text:p.title,groupid:p.owner});
      });
  */
    //const { items } = this.state;
    return this.RenderWithoutModal();

  }
  /*private _onFilter = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
    this.setState({
      items: text ? this._allItems.filter(i => i.name.toLowerCase().indexOf(text) > -1) : this._allItems
    });
  };*/

  private RenderWithoutModal = () => {
    return (
      <div className="Planner">
        <div className='ms-Grid-row' style={{ minHeight: '100vh', minWidth: '100vw', margin: 0 }}>
          <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
            <div className="settingcontainer">
              <span style={{ marginRight: '20px' }} onClick={() => { this.changeviw("MSList"); }} className={this.state.currentview == 'MSList' ? "attendeetype typeselected" : "attendeetype"}>List Configuration</span>
              <span style={{ marginRight: '20px' }} onClick={() => { this.changeviw("Category"); }} className={this.state.currentview == 'Category' ? "attendeetype typeselected" : "attendeetype"}>Category</span>
              <span style={{ marginRight: '20px' }} onClick={() => { this.changeviw("admin"); }} className={this.state.currentview == 'admin' ? "attendeetype typeselected" : "attendeetype"}>Administration</span>
              {/* <span style={{marginRight:'20px'}} onClick={()=>{this.changeviw("Secretary");}} className={this.state.currentview=='Secretary'?"attendeetype typeselected":"attendeetype"}>My Secretary</span>
                <span style={{marginRight:'20px'}}  onClick={()=>{this.changeviw("Manager");}} className={this.state.currentview=='Manager'?"attendeetype typeselected":"attendeetype"}>My Manager</span> */}
              {/* {this.props.AdminURL != '' ?
                (<span style={{ marginRight: '20px' }} onClick={() => { this.changeviw("manageuser"); }}
                  className={this.state.currentview == 'manageuser' ? "attendeetype typeselected" : "attendeetype"}>Users</span>) :
                null} */}

              <div className={this.state.currentview == 'MSList' ? "attendeelist attendeelistactive" : "attendeelist"}>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <div className="buttonarea1" style={{ textAlign: 'right' }}>
                      {this.MySettingInfo.CategoryList != null && this.MySettingInfo.CategoryList.length > 0 ?
                        (
                          <button onClick={() => {
                            this.SelectedList = new MSListConfig();
                            this.state.shownewlistmodal = true;
                            this.setState({ chagnevalue: new Date() });
                          }}
                            className="ms-Button ms-Button--default viewswitchbtn plannertask">
                            New List Configuraiton
                          </button>
                        ) : null
                      }

                    </div>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    {this.MySettingInfo.ListInfo != null && this.MySettingInfo.ListInfo.length > 0 ? this.RenderListInfo() : this.MySettingInfo.CategoryList.length==0?(<div className='emptymessageblock'>Add category from category tab</div>):(<div className='emptymessageblock'>Click on <b>New List Configuration</b>  button to add new configuration</div>)}
                  </div>
                </div>

              </div>
              <div className={this.state.currentview == 'Category' ? "attendeelist attendeelistactive" : "attendeelist"}>
                {this.state.isLoading ? (
                  <div className="mipaloading">&nbsp;</div>
                ) : null}
                <div className='ms-Grid-row'>
                  <div className='ms-Grid-col ms-sm5 ms-md5 ms-lg5'>
                    <TextField
                      value={this.CategoryName}
                      onChange={(event) => {
                        this.CategoryName = event.target["value"];
                        this.setState({ chagnevalue: new Date() });
                      }}
                      label="Category name"
                      placeholder="Category name" />
                  </div>
                  <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                    <TextField
                      onChange={(event) => {
                        this.CategoryHexColor = event.target["value"];
                        this.setState({ chagnevalue: new Date() });
                      }}
                      value={this.CategoryHexColor}
                      label="Color"
                      placeholder="Color Hex" />
                  </div>
                  <div className='ms-Grid-col ms-sm3 ms-md3 ms-lg3 formbuttoncell'>
                    <button style={{ minWidth: '10px', width: '65px' }} onClick={() => { this.SaveCategory(null) }} className="ms-Button ms-Button--primary viewswitchbtn plannertask">
                      Save
                    </button>

                    <button style={{ minWidth: '10px', width: '65px' }} onClick={this.ResetForm} className="ms-Button ms-Button--default viewswitchbtn">
                      Reset
                    </button>
                  </div>

                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{ color: 'red' }}>
                      <ul>
                        {this.FromValidationMessages}
                      </ul>

                    </div>
                  </div>

                </div>

                {this.MySettingInfo.CategoryList != null && this.MySettingInfo.CategoryList.length > 0 ? this.RenderCategoryInfo() : null}

              </div>
              <div className={this.state.currentview == 'admin' ? "attendeelist attendeelistactive" : "attendeelist"}>
              <div className='ms-Grid-row' style={{ padding: 15 }}>
                        <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
                            <label>Using the Microsoft 365 tenant Global Administration Account, please click on following button to grant admin consent to set the required Microsoft Graph permission. Notice, a pop up will open showing the required permissions for using the Graph API. This permission is NOT given to iGlobe, but for your users on your tenant. Click on Accept to give Admin consent.</label>
                        </div>
                        <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{ paddingTop: 20 }}>
                            <a className='ms-Button ms-Button--default viewswitchbtn adminconsent' href='https://login.microsoftonline.com/common/oauth2/authorize?IsDlg=1&client_id=e854ea05-68ab-4204-babe-db4a784fb4d8&scope=Web.Read%20List.Manage&response_type=code&redirect_uri=https%3A%2F%2Fmipa.iglobe.dk%2FAuth&state=onlyconsent&prompt=admin_consent'
                                target="_blank"  >Admin Consent</a>
                        </div>
                    </div>
              </div>
              <div className={this.state.currentview == 'Secretary' ? "attendeelist attendeelistactive" : "attendeelist"}>
                <div className='ms-Grid'>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
                      {this.props.SacretaryList != null && this.props.SacretaryList.length > 0 ? this.RenderSacretaryListInfo() : null}
                    </div>

                  </div>
                </div>
              </div>

              <div className={this.state.currentview == 'Manager' ? "attendeelist attendeelistactive" : "attendeelist"}>
                {this.props.Manager != null ? (
                  <div className='ms-Grid'>
                    <div className='ms-Grid-row' style={{ padding: 5, borderBottom: '1px solid #eee' }}>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Name: </b></div>
                      <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.Name}</div>
                    </div>
                    <div className='ms-Grid-row' style={{ padding: 5, borderBottom: '1px solid #eee' }}>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Job Title: </b></div>
                      <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.jobTitle}</div>
                    </div>
                    <div className='ms-Grid-row' style={{ padding: 5, borderBottom: '1px solid #eee' }}>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Email: </b></div>
                      <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.Email}</div>
                    </div>
                    <div className='ms-Grid-row' style={{ padding: 5, borderBottom: '1px solid #eee' }}>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Mobile: </b></div>
                      <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.mobilePhone}</div>
                    </div>
                  </div>
                ) : null}

              </div>
            </div>
          </div>
        </div>



        {this.state.shownewlistmodal ?
          <NewMysetting
            closeMethod={this.ShowHideNewModal}
            UserSiteURL={this.props.SiteURL}
            //setTasklink={this.SaveLinkToTask}
            phrases={this.props.Phrases}
            APIServiceurl={this.props.APIServiceurl}
            APIHeader={this.props.APIHeader}
            UserEmail={this.props.UserEmail}
            CategoryList={this.MySettingInfo.CategoryList}
            ListInfo={this.SelectedList}
          /> : null
        }

      </div>
    );
  }
  // private RenderInModal=()=>{
  //   return (
  //     <div className="Planner">  

  //       <Modal
  //         titleAriaId={this._titleId}
  //         subtitleAriaId={this._subtitleId}
  //         isOpen={true}
  //         onDismiss={this.props.closeMethod}
  //         isBlocking={true}
  //         containerClassName={contentStyles.container}
  //         /* dragOptions={this._dragOptions} */
  //       >
  //       <div className={contentStyles.header}>
  //       <span id={this._titleId}>My Setting</span>
  //       {this.state.isLoading ? (
  //             <div className="mipaloading">&nbsp;</div>
  //           ) : null}
  //       <IconButton
  //         styles={iconButtonStyles}
  //         iconProps={{ iconName: 'Cancel' }}
  //         ariaLabel="Close popup modal"
  //         onClick={this.props.closeMethod as any}
  //       />
  //       </div>

  //       <div className='ms-Grid-row' style={{minHeight:'70vh',minWidth:'70vw',margin:0}}>
  //         <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
  //           <div className="settingcontainer">
  //               <span style={{marginRight:'20px'}}  onClick={()=>{this.changeviw("MSList");}} className={this.state.currentview=='MSList'?"attendeetype typeselected":"attendeetype"}>List Configuration</span>
  //               <span style={{marginRight:'20px'}}  onClick={()=>{this.changeviw("Category");}} className={this.state.currentview=='Category'?"attendeetype typeselected":"attendeetype"}>Category</span>
  //               {/* <span style={{marginRight:'20px'}} onClick={()=>{this.changeviw("Secretary");}} className={this.state.currentview=='Secretary'?"attendeetype typeselected":"attendeetype"}>My Secretary</span>
  //               <span style={{marginRight:'20px'}}  onClick={()=>{this.changeviw("Manager");}} className={this.state.currentview=='Manager'?"attendeetype typeselected":"attendeetype"}>My Manager</span> */}
  //               {this.props.AdminURL!=''?
  //               (<span style={{marginRight:'20px'}}  onClick={()=>{this.changeviw("manageuser");}} 
  //               className={this.state.currentview=='manageuser'?"attendeetype typeselected":"attendeetype"}>Users</span>):
  //               null}

  //               <div className={this.state.currentview=='MSList'?"attendeelist attendeelistactive":"attendeelist"}>
  //                 <div className="ms-Grid-row">
  //                     <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
  //                         <div className="buttonarea1" style={{textAlign:'right'}}>
  //                           {this.MySettingInfo.CategoryList!=null && this.MySettingInfo.CategoryList.length>0?
  //                           (
  //                             <button onClick={()=>{
  //                               this.SelectedList=new MSListConfig();
  //                               this.state.shownewlistmodal=true;
  //                               this.setState({ chagnevalue:new Date() });}} 
  //                               className="ms-Button ms-Button--default viewswitchbtn plannertask">
  //                               New List Configuraiton
  //                             </button>
  //                           ):null
  //                           }

  //                         </div>
  //                     </div>
  //               </div>
  //       <div className="ms-Grid-row">
  //           <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
  //           {this.MySettingInfo.ListInfo!=null && this.MySettingInfo.ListInfo.length>0? this.RenderListInfo():null}
  //           </div>
  //       </div>

  //             </div>
  //             <div className={this.state.currentview=='Category'?"attendeelist attendeelistactive":"attendeelist"}>

  //                  <div className='ms-Grid-row'>
  //                    <div className='ms-Grid-col ms-sm5 ms-md5 ms-lg5'>
  //                    <TextField 
  //                       value={this.CategoryName}
  //                       onChange={(event)=>{
  //                           this.CategoryName=event.target["value"];
  //                           this.setState({ chagnevalue:new Date() });
  //                       }}  
  //                       label="Category name"
  //                       placeholder="Category name" />  
  //                    </div>
  //                    <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
  //                    <TextField 
  //                       onChange={(event)=>{
  //                           this.CategoryHexColor=event.target["value"];
  //                           this.setState({ chagnevalue:new Date() });
  //                       }}  
  //                       value={this.CategoryHexColor}
  //                       label="Color"
  //                       placeholder="Color Hex" />  
  //                   </div>
  //                   <div className='ms-Grid-col ms-sm3 ms-md3 ms-lg3 formbuttoncell'>
  //                         <button style={{minWidth:'10px',width:'65px'}} onClick={()=>{this.SaveCategory(null)}} className="ms-Button ms-Button--primary viewswitchbtn plannertask">
  //                           Save
  //                         </button>

  //                         <button style={{minWidth:'10px',width:'65px'}}  onClick={this.ResetForm} className="ms-Button ms-Button--default viewswitchbtn">
  //                           Reset
  //                         </button>
  //                   </div>

  //                   <div className='ms-Grid-row'>
  //                     <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{color:'red'}}>
  //                     <ul>
  //                       {this.FromValidationMessages}
  //                     </ul>

  //                   </div>
  //                   </div>

  //                  </div>

  //                   {this.MySettingInfo.CategoryList!=null && this.MySettingInfo.CategoryList.length>0?  this.RenderCategoryInfo():null}

  //             </div>
  //             <div  className={this.state.currentview=='Secretary'?"attendeelist attendeelistactive":"attendeelist"}>
  //                    <div className='ms-Grid'>
  //                       <div className='ms-Grid-row'>
  //                         <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
  //                         {this.props.SacretaryList!=null && this.props.SacretaryList.length>0? this.RenderSacretaryListInfo():null}
  //                         </div>

  //                       </div>
  //                   </div>     
  //             </div>

  //             <div  className={this.state.currentview=='Manager'?"attendeelist attendeelistactive":"attendeelist"}>
  //             {this.props.Manager!=null?(
  //               <div className='ms-Grid'>
  //               <div className='ms-Grid-row' style={{padding:5,borderBottom:'1px solid #eee'}}>
  //                 <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Name: </b></div>
  //                 <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.Name}</div>
  //               </div>
  //               <div className='ms-Grid-row' style={{padding:5,borderBottom:'1px solid #eee'}}>
  //                 <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Job Title: </b></div>
  //                 <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.jobTitle}</div>
  //               </div>
  //               <div className='ms-Grid-row' style={{padding:5,borderBottom:'1px solid #eee'}}>
  //                 <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Email: </b></div>
  //                 <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.Email}</div>
  //               </div>
  //               <div className='ms-Grid-row' style={{padding:5,borderBottom:'1px solid #eee'}}>
  //                 <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'><b>Mobile: </b></div>
  //                 <div className='ms-Grid-col ms-sm10 ms-md10 ms-lg10'>{this.props.Manager.mobilePhone}</div>
  //               </div>
  //           </div>
  //               ):null}

  //             </div>
  //             <div  className={this.state.currentview=='manageuser'?"attendeelist attendeelistactive":"attendeelist"}>
  //             <div className='ms-Grid'>
  //                       <div className='ms-Grid-row' style={{padding:15,borderBottom:'1px solid #eee',textAlign:'right'}}>

  //                         <a className='ms-Button ms-Button--default viewswitchbtn plannertask' href={this.props.AdminURL} target="_blank" style={{textDecoration:'none'}} >Manage users</a>

  //                       </div>

  //                   </div>
  //             </div>                    

  //       </div>
  //         </div>
  //       </div>


  //       </Modal>
  //       {this.state.shownewlistmodal?
  //       <NewMysetting 
  //         closeMethod={this.ShowHideNewModal}
  //         UserSiteURL={this.props.SiteURL}
  //         //setTasklink={this.SaveLinkToTask}
  //         phrases={this.props.Phrases}
  //         APIServiceurl={this.props.APIServiceurl}
  //         APIHeader={this.props.APIHeader}   
  //         UserEmail={this.props.UserEmail}
  //         CategoryList={this.MySettingInfo.CategoryList}
  //         ListInfo={this.SelectedList}
  //       />:null 
  //      }

  //     </div>
  //     );
  // }
  private RenderListInfo = () => {
    let items = [];
    for (let i = 0; i < this.MySettingInfo.ListInfo.length; i++) {
      items.push({
        key: i,
        ID: this.MySettingInfo.ListInfo[i].ID,
        SiteURL: this.MySettingInfo.ListInfo[i].SiteURL,
        ListTitle: this.MySettingInfo.ListInfo[i].ListTitle,
        Category: this.MySettingInfo.ListInfo[i].Category.CategoryName,
        FullData: this.MySettingInfo.ListInfo[i]
      });
    }

    let columns = [
      { key: 'column1', name: 'ListTitle', fieldName: 'ListTitle', minWidth: 100, maxWidth: 200, isResizable: true },
      { key: 'column2', name: 'Category', fieldName: 'Category', minWidth: 100, maxWidth: 200, isResizable: true },
      { key: 'column3', name: 'SiteURL', fieldName: 'SiteURL', minWidth: 100, maxWidth: 200, isResizable: true },
      {
        key: "column4",
        name: "",
        fieldName: '',
        minWidth: 160,
        maxWidth: 280,
        isResizable: true,
        onRender: (item) => (
          <div >
            <i className="ms-Icon ms-Icon--EditSolid12 mslistedit" onClick={() => {
              this.SelectedList = this.MySettingInfo.ListInfo[item.key];
              this.state.shownewlistmodal = true;
              this.setState({ chagnevalue: new Date() });
            }} title='Edit' ></i>
            <i className="ms-Icon ms-Icon--Blocked2 mslistremove" title='Remove'
              onClick={() => {
                this.RemoveListInfo(item.ID)
              }}
            ></i>

          </div>
        )
      }
    ];
    let datalist = (
      <DetailsList
        items={items}
        columns={columns}
        selectionMode={SelectionMode.none}
        setKey="set"
        layoutMode={DetailsListLayoutMode.justified}
        selection={this._selection}
        selectionPreservedOnEmptyClick={true}
        ariaLabelForSelectionColumn="Toggle selection"
        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
        checkButtonAriaLabel="Row checkbox"
        onItemInvoked={(selectedlist) => {
          this.SelectedList = selectedlist.FullData;
          this.state.shownewlistmodal = true;
          this.setState({ chagnevalue: new Date() });
        }}
      />
    );

    return datalist;
  }
  private RenderSacretaryListInfo = () => {

    let columns = [
      { key: 'column1', name: 'Name', fieldName: 'Name', minWidth: 100, maxWidth: 200, isResizable: true },
      { key: 'column2', name: 'Email', fieldName: 'Email', minWidth: 100, maxWidth: 200, isResizable: true },
      { key: 'column3', name: 'Job Title', fieldName: 'jobTitle', minWidth: 100, maxWidth: 200, isResizable: true },
      { key: 'column4', name: 'Mobile', fieldName: 'mobilePhone', minWidth: 100, maxWidth: 200, isResizable: true },
    ];
    let datalist = (
      <DetailsList
        items={this.props.SacretaryList}
        columns={columns}
        selectionMode={SelectionMode.none}
        setKey="set"
        layoutMode={DetailsListLayoutMode.justified}
        selection={this._selection}
        selectionPreservedOnEmptyClick={true}
        ariaLabelForSelectionColumn="Toggle selection"
        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
        checkButtonAriaLabel="Row checkbox"
        onItemInvoked={(selectedlist) => {

        }}
      />
    );

    return datalist;
  }
  private RenderCategoryInfo = () => {
    let items = [];
    for (let i = 0; i < this.MySettingInfo.CategoryList.length; i++) {
      items.push({
        key: i,
        ID: this.MySettingInfo.CategoryList[i].ID,
        Name: this.MySettingInfo.CategoryList[i].CategoryName,
        ColorCode: this.MySettingInfo.CategoryList[i].ColorHex,
        UsedCount: this.MySettingInfo.CategoryList[i].NoOfList,
      });
    }

    let columns = [
      { key: 'column1', name: 'Name', fieldName: 'Name', minWidth: 100, maxWidth: 200, isResizable: true },
      //{ key: 'column2', name: 'Color', fieldName: 'ColorCode', minWidth: 100, maxWidth: 200, isResizable: true },
      {
        key: "column2",
        name: "Color",
        fieldName: 'ColorCode',
        minWidth: 160,
        maxWidth: 280,
        isResizable: true,
        onRender: (item) => (
          <div style={{ background: item.ColorCode, textAlign: 'center', color: '#fff' }}>
            {item.ColorCode}

          </div>
        )
      },
      { key: 'column3', name: 'Used Count', fieldName: 'UsedCount', minWidth: 100, maxWidth: 200, isResizable: true },
      {
        key: "column4",
        name: "",
        fieldName: '',
        minWidth: 160,
        maxWidth: 280,
        isResizable: true,
        onRender: (item) => (
          <div >
            <i className="ms-Icon ms-Icon--EditSolid12 mslistedit" onClick={() => {
              this.PrepareCategoryForm(item);
            }} title='Edit' ></i>
            {item.UsedCount <= 0 ? (
              <i className="ms-Icon ms-Icon--Blocked2 mslistremove" title='Remove'
                onClick={() => {
                  this.SaveCategory(item.ID)
                }}
              ></i>
            ) : null}

          </div>
        )
      }
    ];
    let datalist = (
      <DetailsList
        items={items}
        columns={columns}
        selectionMode={SelectionMode.none}
        setKey="set"
        layoutMode={DetailsListLayoutMode.justified}
        selection={this._selection}
        selectionPreservedOnEmptyClick={true}
        ariaLabelForSelectionColumn="Toggle selection"
        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
        checkButtonAriaLabel="Row checkbox"
        onItemInvoked={(selectdCat) => {
          this.PrepareCategoryForm(selectdCat);
        }}
      />
    );

    return datalist;
  }
  private PrepareCategoryForm = (selectdCat) => {
    this.CategoryHexColor = selectdCat.ColorCode;
    this.CategoryName = selectdCat.Name;
    this.CategoryId = selectdCat.ID;
    this.setState({ changeed: true });
  };
  public changeviw = (newview) => {
    if (this.state.currentview != newview) {
      this.setState({ currentview: newview });
    }
  }
  /* private _onItemInvoked = (item: IDetailsListBasicExampleItem): void => {
    alert(`Item invoked: ${item.name}`);
  }; */
  private _getSelectionDetails = () => {
    const selectionCount = this._selection.getSelectedCount();

    switch (selectionCount) {
      case 0:
        return 'No items selected';
      case 1:
        return '1 item selected: ' + (this._selection.getSelection()[0] as IDetailsListBasicExampleItem).name;
      default:
        return `${selectionCount} items selected`;
    }
  }

  private ShowHideProgress = value => {

    this.RequestPending += value;
    if (this.RequestPending <= 0) {
      this.RequestPending = 0;
      if (this.ProgressIsShowing) {
        this.setState({ isLoading: false });
        this.ProgressIsShowing = false;
      }
    } else if (this.ProgressIsShowing == false) {
      this.ProgressIsShowing = true;
      this.setState({ isLoading: true });
    }
  }
  private ShowHideNewModal = (value, data) => {
    if (data != null) {
      this.props.UpdateConfig(data, true);
      this.MySettingInfo = data;
    }
    this.setState({ shownewlistmodal: value });
  }
  public SaveCategory = (removeid) => {
    this.FromValidationMessages = [];
    let ID = removeid;
    if (removeid == null) {
      ID = this.CategoryId;
      if (this.CategoryName == '') {
        this.FromValidationMessages.push(<li>Please provice category name</li>);
      }
      if (this.CategoryHexColor == '') {
        this.FromValidationMessages.push(<li>Please provice color code or name</li>);
      }
      if (this.FromValidationMessages.length > 0) {
        this.setState({ changeed: true });
        return;
      }

    }
    var api =
      "/SaveMIPAListCategory";
    let catobj = {
      ID: ID,
      CategoryName: this.CategoryName,
      ColorHex: this.CategoryHexColor
    };
    let configobj = {
      //ListTitle:this.ListTitle,
      SiteURL: this.props.SiteURL,
      UserEmail: this.props.UserEmail
    };
    var objRequest = {
      config: configobj,
      category: catobj
    };
    this.SRequest.Post(
      this.props.APIServiceurl,
      api,
      objRequest,
      (successres) => {
        if (successres && successres.data && successres.data.IsSuccess) {
          this.MySettingInfo = successres.data.data;
          this.props.UpdateConfig(successres.data.data, true);
          this.ResetForm();
        }
      },
      (errorres) => {
        this.ShowHideProgress(-1);
        console.log(errorres);
      },
      this.ShowHideProgress,
      this.props.APIHeader
    );
  }
  private RemoveListInfo = (listinfoid) => {

    var api =
      "/SaveMIPAListInformation";
    let catlist = {
      ID: listinfoid
    };
    let configobj = {
      SiteURL: this.props.SiteURL,
      UserEmail: this.props.UserEmail
    };
    var objRequest = {
      config: configobj,
      listinfo: catlist
    };
    this.SRequest.Post(
      this.props.APIServiceurl,
      api,
      objRequest,
      (successres) => {
        if (successres && successres.data && successres.data.IsSuccess) {
          this.MySettingInfo = successres.data.data;
          this.props.UpdateConfig(successres.data.data, true);
          this.setState({ changeed: true });
        }
      },
      (errorres) => {
        this.ShowHideProgress(-1);
        console.log(errorres);
      },
      this.ShowHideProgress,
      this.props.APIHeader
    );
  }
  public ResetForm = () => {
    this.CategoryHexColor = '';
    this.CategoryName = '';
    this.FromValidationMessages = [];
    this.CategoryId = Helper.newguid();
    this.setState({ changeed: true });
  }
}
